
import { isSet, optionsToKeyValuePairs } from "../../../../../../utils/commonUtils";
import { computationRules1 } from "./DrugScreenCollection";

export const ScreeningVF = (props,type)=>{
    const stackedFieldStyle = {
        layout: 'stacked',
        showContainerBorder: false,
        labelWrap: false,
        isLabel: false,
      };
    const {formData} = props;
    let note = '';
    let activityFields = [];
    if(type==='VF'){
        note = 'At least 70° field of vision in horizontal meridian measured in each eye.';
        activityFields = [
            {
                label:'Horizontal Field of Vision',
                type:'Label',
                appendClass:'bg-light',
                col:'col-12',
            },
            {
                label:'Right Eye: (degrees)',
                type:'TextInput',
                col:'col-6',
                rangeMin:70,
                name:'horizontal_field_of_vision_right_eye',
                id:'horizontal_field_of_vision_right_eye',
            },
            {
                label:'Left Eye: (degrees)',
                type:'TextInput',
                col:'col-6',
                rangeMin:70,
                name:'horizontal_field_of_vision_left_eye',
                id:'horizontal_field_of_vision_left_eye',
            }
        ]
    }else  if(type==='VJ'){
        note = 'Standard is below 20/40 acuity (Jaeger) in each eye with or without correction.';
        activityFields =[
            {
                label:'Uncorrected',
                type:'Label',
                // rules:[{rule:[{field:'wearing_corrective_lenses',value:1,operator:'==='}],action:''}],
                appendClass:'bg-light',
                col:'col-12',
            },
            {
                label:'Right Eye',
                type:'TextInput',
                rangeMax:40,
                // rules:[{rule:[{field:'wearing_corrective_lenses',value:1,operator:'==='}],action:'CLEAR'}],
                isNumeric:true,
                col:'col-6',
                name:'uncorrected_right_eye',
                id:'uncorrected_right_eye',
            },
            {
                label:'Left Eye:',
                type:'TextInput',
                rangeMax:40,
                // rules:[{rule:[{field:'wearing_corrective_lenses',value:1,operator:'==='}],action:'CLEAR'}],
                isNumeric:true,
                col:'col-6',
                name:'uncorrected_left_eye',
                id:'uncorrected_left_eye',
            },
            {
                label:'Both Eyes:',
                type:'TextInput',
                rangeMax:40,
                // rules:[{rule:[{field:'wearing_corrective_lenses',value:1,operator:'==='}],action:'CLEAR'}],
                isNumeric:true,
                col:'col-6',
                name:'uncorrected_both_eyes',
                id:'uncorrected_both_eyes',
            },

            {
                label:'Corrected',
                type:'Label',
                appendClass:'bg-light',
                // rules:[{rule:[{field:'wearing_corrective_lenses',value:1,operator:'==='}],action:'SHOW'}],
                col:'col-12',
            },
            {
                label:'Right Eye',
                type:'TextInput',
                col:'col-6',
                rangeMax:40,
                isNumeric:true,
                // rules:[{rule:[{field:'wearing_corrective_lenses',value:1,operator:'==='}],action:'SHOW'}],
                name:'corrected_right_eye',
                id:'corrected_right_eye',
            },
            {
                label:'Left Eye:',
                type:'TextInput',
                col:'col-6',
                rangeMax:40,
                // rules:[{rule:[{field:'wearing_corrective_lenses',value:1,operator:'==='}],action:'SHOW'}],
                isNumeric:true,
                name:'corrected_left_eye',
                id:'corrected_left_eye',
            },
            {
                label:'Both Eyes:',
                type:'TextInput',
                rangeMax:40,
                // rules:[{rule:[{field:'wearing_corrective_lenses',value:1,operator:'==='}],action:'SHOW'}],
                isNumeric:true,
                col:'col-6',
                name:'corrected_both_eyes',
                id:'corrected_both_eyes',
            },
        ]
    }else  if(type==='VS'){
        note = 'Standard is below 20/40 acuity (Snelling) in each eye with or without correction.';
        activityFields =[
            {
                label:'Uncorrected',
                type:'Label',
                // rules:[{rule:[{field:'wearing_corrective_lenses',value:0,operator:'==='}],action:'SHOW'}],
                appendClass:'bg-light',
                col:'col-12',
            },
            {
                label:'Right Eye',
                type:'TextInput',
                rangeMax:40,
                // rules:[{rule:[{field:'wearing_corrective_lenses',value:0,operator:'==='}],action:'SHOW'}],
                isNumeric:true,
                col:'col-4',
                name:'uncorrected_right_eye',
                id:'uncorrected_right_eye',
            },
            {
                label:'Left Eye:',
                type:'TextInput',
                rangeMax:40,
                // rules:[{rule:[{field:'wearing_corrective_lenses',value:0,operator:'==='}],action:'SHOW'}],
                isNumeric:true,
                col:'col-4',
                name:'uncorrected_left_eye',
                id:'uncorrected_left_eye',
            },
            {
                label:'Both Eyes:',
                type:'TextInput',
                rangeMax:40,
                // rules:[{rule:[{field:'wearing_corrective_lenses',value:0,operator:'==='}],action:'SHOW'}],
                isNumeric:true,
                col:'col-4',
                name:'uncorrected_both_eyes',
                id:'uncorrected_both_eyes',
            },

            {
                label:'Corrected',
                type:'Label',
                appendClass:'bg-light',
                // rules:[{rule:[{field:'wearing_corrective_lenses',value:1,operator:'==='}],action:'SHOW'}],
                col:'col-12',
            },
            {
                label:'Right Eye',
                type:'TextInput',
                col:'col-4',
                rangeMax:40,
                isNumeric:true,
                // rules:[{rule:[{field:'wearing_corrective_lenses',value:1,operator:'==='}],action:'SHOW'}],
                name:'corrected_right_eye',
                id:'corrected_right_eye',
            },
            {
                label:'Left Eye:',
                type:'TextInput',
                col:'col-4',
                rangeMax:40,
                // rules:[{rule:[{field:'wearing_corrective_lenses',value:1,operator:'==='}],action:'SHOW'}],
                isNumeric:true,
                name:'corrected_left_eye',
                id:'corrected_left_eye',
            },
            {
                label:'Both Eyes:',
                type:'TextInput',
                rangeMax:40,
                // rules:[{rule:[{field:'wearing_corrective_lenses',value:1,operator:'==='}],action:'SHOW'}],
                isNumeric:true,
                col:'col-4',
                name:'corrected_both_eyes',
                id:'corrected_both_eyes',
            },
        ]
    }
    const charts = [{
        type:'Grid',
        col:'col-md-3',
        data:[{
            type:"PatientDetails",
            employeeDetails:props.employeeDetails,
            visitDetails:props.visitDetails
        },{
            type:"CompanyDetails",
            companyDetails:props.companyDetails
        }],
    },{
        type:'Tab',
        col:'col-md-9',
        data:[
            {
                id:'vf_details',
                label:'VF Details',
                data:[
        {
            label:'Activity Details - '+props.activityName,
            note:note,
            fields:[
                {
                    label:'Wearing corrective lenses',
                    col:'col-6',
                    type:'RadioGroup',
                    name:'wearing_corrective_lenses',
                    id:'wearing_corrective_lenses',
                    options:[{label:'Yes',value:1},{label:'No',value:0}],
                },
                {
                    type:'Blank',
                    name:'blank'
                },
               ...activityFields
        ]
        },
    
        {
            label: "Notes",
            // labelStyle: "fw-semibold",
            fieldProps: stackedFieldStyle,
            fields:[
                {
                    label:'Notes',
                    col:'col-12',
                    type: "NewTextArea",
                    label: "Notes",
                    placeholder: "Add Comments",
                    className: "form-control form-control-solid",
                    name: "notes",
                    col: "col-12 border-0",
                    name:'notes',
                },
                // {
                //     label:'Suggested Result',
                //     type:'TextInput',
                //     disabled:true,
                //     options:isSet(props.lookupsOptions['chartResult'],[]),
                //     name:'suggested_status',
                // },
                {
                    type:'Blank',
                    name:'blank'
                },
            // {
            //     label:'Final Determination',
            //     type:'SelectList',
            //     options:isSet(props.lookupsOptions['chartResult'],[]),
            //     name:'status',
            // },
           
           
        ]
        },
        {
            label: 'Review / Completion',
            // labelStyle: 'fw-semibold',
            fields: [
                {
                    type: 'ProviderSignOff',
                    col: 'col-12',
                    fields: [
                        { label: 'Signature PIN', name: 'provider_pin', col: 'col-12' },
                        { label: 'Signature', type: 'NewSignature', name: 'provider_signature', col: 'col-12' },
                        { label: 'Date', type: 'Date', name: 'signed_date', col: 'col-12' },
                        // { label : "Suggested Result", disabled:true,placeholder:'Not Started',type: "TextInput", name: "suggested_status", col: "col-6"},
                        // { label : "Final Results", type: "SelectList", name: "status", col: "col-12", options:isSet(props.lookupsOptions['chartResult'],[]),statusBasedColor: true },
                        { label : "Final Results", type: "SelectList", name: "status", col: "col-12", options: optionsToKeyValuePairs(['Not Started','Pending','Normal','Abnormal','Negative','Positive','Dispensed','Administered','Failed','Passed','Non-Negative','Cancelled','Inconclusive']),statusBasedColor: true },
                        // { label : "Activity Status", type: "SelectList", name: "activity_status", col: "col-12", options: optionsToKeyValuePairs(['Not Started','Ordered','Completed','Cancelled']),statusBasedColor: true },
                        { label : "Activity Status", type: "SelectList", name: "activity_status", col: "col-12", options: optionsToKeyValuePairs(['Not Started','Pending','Pending Lab Confirmation','Pending MRO Confirmation','Ready for Review','Completed','Cancelled']),statusBasedColor: true },
                    ],
                },
            ],
        }
                ]
            },
            {
                id:'Images',
                label:'Images',
                data:[]
            }
        ]
    }];
    const defaultValue = {
        status:'Not Started',
        suggested_status:'Not Started',
        activity_status:'Not Started',
        // reason:'Pre-employment'
    };
    const headers = [{
        type: 'Tab',
        data: [
            {
                label: 'VF Details',
                id: 'vf_details'
            },
            {
                label: 'Images',
                id: 'Images'
            }
        ]
    }];
    return {charts,defaultValue,headers,computationFunction: (formData,key) => ({...computationRules(formData,key,type), ...computationRules1(formData,key)})};
}


const computationRules = (formData,key,type)=>{
    let status = 'Not Started';
    let activity_status = 'Not Started';
    const wearing_corrective_lenses = isSet(formData['wearing_corrective_lenses'],null);
    const conditions = wearing_corrective_lenses===0?'uncorrected':'corrected';
    if((type==='VS' || type=='VJ') && wearing_corrective_lenses!==null){
        // if(wearing_corrective_lenses===1){
            const rightEye  = isSet(formData[''+conditions+'_right_eye'],'');
            const bothEyes  = isSet(formData[''+conditions+'_both_eyes'],'');
            const leftEye  = isSet(formData[''+conditions+'_left_eye'],'');

            if (rightEye === '' || bothEyes === '' || leftEye === '') {
                status = 'Pending';
                activity_status = 'Pending';
            } else if (rightEye > 40 || bothEyes > 40 || leftEye > 40) {
                status = 'Failed';
                activity_status = 'Completed';
            } else {
                status = 'Passed';
                activity_status = 'Completed';
            }
        // }
    }else if(type==='VF'){
        const horizontalRighteye = isSet(formData['horizontal_field_of_vision_right_eye'],'');
        const horizontalLeftEye = isSet(formData['horizontal_field_of_vision_left_eye'],'');
        if(horizontalRighteye==='' || horizontalLeftEye===''){
            status = 'Pending';
            activity_status = 'Pending';
        }else if(horizontalRighteye<70 ||  horizontalLeftEye<70){
            status = 'Failed';
            activity_status = 'Completed';
        }else{
            status = 'Passed';
            activity_status = 'Completed';
        }
    }
    
    
    return (key==='status' || key==='activity_status')?{}:{'status':status,'suggested_status':status,'activity_status':activity_status};
}